"use strict";

define('rs/modals/training.finder/training.finder.controller',['require','exports','module','underscore','rs/modals/table.finder/table.finder.controller','rs/modals/training.finder/training.finder.view','rs/models/training','bluebird'],function (require, exports, module) {
  var _ = require('underscore');
  var TableFinderController = require('rs/modals/table.finder/table.finder.controller');
  var TrainingFinderView = require('rs/modals/training.finder/training.finder.view');
  var Training = require('rs/models/training');
  var Promise = require('bluebird');
  var COLUMNNAME_STATUS = 'status';
  var TrainingFinderController = TableFinderController.extend({
    defaultTitle: 'Training Finder',
    citiEnabled: false,
    email: '',
    buttons: [{
      text: 'Close',
      dismiss: true,
      icon: 'ban'
    }],
    columns: [{
      name: 'course',
      displayName: 'Course Name',
      type: 'String',
      width: '34%'
    }, {
      name: 'group',
      displayName: 'Group',
      type: 'String',
      width: '16%'
    }, {
      name: 'stage',
      displayName: 'Stage',
      type: 'String',
      width: '13%'
    }, {
      name: COLUMNNAME_STATUS,
      displayName: 'Status',
      className: 'status',
      type: 'String',
      width: '11%'
    }, {
      name: 'completedDate',
      displayName: 'Completion Date',
      type: 'String',
      width: '13%'
    }, {
      name: 'expirationDate',
      displayName: 'Expiration Date',
      type: 'String',
      width: '13%'
    }],
    CLASSNAME_EXPIRED: 'expired',
    initialize: function initialize() {
      this._setCitiEnabled();
      this._super.apply(this, arguments);
    },
    processFilter: function processFilter(items, filter) {
      if (filter.field) {
        return _.filter(items, function (item) {
          if (item.item[filter.field] == filter.value) {
            return true;
          }
        });
      }
      return items;
    },
    processTableItemCell: function processTableItemCell(tableItemCell, tableItem, column) {
      if (this._isStatusColumn(column) && this._isExpiredTableItem(tableItem)) {
        tableItemCell.className = _.isUndefined(tableItemCell.className) ? this.CLASSNAME_EXPIRED : tableItemCell.className + ' ' + this.CLASSNAME_EXPIRED;
      }
      return tableItemCell;
    },
    _isExpiredTableItem: function _isExpiredTableItem(tableItem) {
      return tableItem.item && tableItem.item.get('status') === tableItem.item.EXPIRED;
    },
    _isStatusColumn: function _isStatusColumn(column) {
      return column.name === COLUMNNAME_STATUS;
    },
    _setCitiEnabled: function _setCitiEnabled() {
      var citiEnabledSetting = app.settings.models.find(function (setting) {
        return setting.id === app.config.IRB_CITI_ENABLED_NAME;
      });
      this.citiEnabled = citiEnabledSetting && citiEnabledSetting.get('value') === true;
    },
    _requestTableItems: function _requestTableItems(email) {
      if (this.citiEnabled) {
        return Training.requestDetails(email);
      }
      return Promise.reject();
    },
    _showRequestedItems: function _showRequestedItems(searchQuery, view) {
      var enabled = this.citiEnabled;
      return this._requestTableItems(this.email).then(function (items) {
        view.showTableContents(items, enabled);
        return items;
      })["catch"](function () {
        var items = [];
        view.showTableContents(items, enabled);
        return items;
      });
    },
    setupView: function setupView() {
      this.setView(new TrainingFinderView());
    }
  }, {
    show: function show(properties, modalOptions) {
      this.email = properties.email;
      return TableFinderController.show.apply(this, arguments).then(function (trainings) {
        return Promise.map(data, function (t) {
          return t;
        });
      });
    }
  });
  module.exports = TrainingFinderController;
});

